import "core-js/modules/es.array.splice.js";
import { formRules } from "@/js/form_rules.js";
import { request } from "@/js/http/http_request";
export default {
  name: "SubscribtionInvitationModal",
  data: function data() {
    return {
      subscribtionInvitationModalShown: false,
      form: {
        valid: false,
        sending: false,
        items: [],
        message: null
      },
      rules: formRules
    };
  },
  methods: {
    open: function open() {
      this.subscribtionInvitationModalShown = true;
    },
    close: function close() {
      this.subscribtionInvitationModalShown = false;
    },
    sendInvites: function sendInvites() {
      this.form.sending = true;
      var _this = this;
      request("/v1/invite/subscribe", "post", {
        SendTo: _this.form.items,
        Message: _this.form.message
      }, true, "api").then(function (response) {
        _this.$toasted.show("Invitations were successfully sent.", {
          type: "success"
        });
        _this.form.items = [];
        _this.form.message = "";
      }).catch(function (error) {
        _this.$toasted.show("Unable to sent invitations. Please contact an administrator.", {
          type: "error"
        });
      });
      this.form.sending = false;
      this.close();
    },
    removeMail: function removeMail(item) {
      this.form.items.splice(this.form.items.indexOf(item), 1);
    }
  }
};